export const attributesByCategory = [
	{
		id: 'attc_01GW2HHFV3DJ380F351SKB0B74',
		tag: 'additional-information',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFV3YJ2AWADHVKG79BQ0',
					icon: null,
					tag: 'at-capacity',
					tsKey: 'additional.at-capacity',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'EXCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFV4D5ZHFMAE7852GB4P',
					icon: null,
					tag: 'geo-near-public-transit',
					tsKey: 'additional.geo-near-public-transit',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFV48VQJBMFA05QCBBV9',
					icon: null,
					tag: 'geo-public-transit-description',
					tsKey: 'additional.geo-public-transit-description',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFV3BADK80TG0DXXFPMM',
					icon: null,
					tag: 'has-confidentiality-policy',
					tsKey: 'additional.has-confidentiality-policy',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'INCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFV5Q7XN2ZNTYFR1AD3M',
					icon: 'carbon:globe',
					tag: 'offers-remote-services',
					tsKey: 'additional.offers-remote-services',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'INCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFV4TM7H5V6FHWA7S9JK',
					icon: null,
					tag: 'time-walk-in',
					tsKey: 'additional.time-walk-in',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFV5FYXQNGTPAQB7G2TF',
					icon: 'carbon:accessibility',
					tag: 'wheelchair-accessible',
					tsKey: 'additional.wheelchair-accessible',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GYSVX1N9T91BJYSHRDPCHJBS',
		tag: 'alerts',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GYSVX1NAMR6RDV6M69H4KN3T',
					icon: 'carbon:information-filled',
					tag: 'info',
					tsKey: 'alerts.info',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GYSVX1NAKP7C6JKJ342ZM35M',
					icon: 'carbon:warning-filled',
					tag: 'warn',
					tsKey: 'alerts.warn',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVFKNMYPN8F86M0H576',
		tag: 'cost',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVGWKWB53HWAAHQ9AAZ',
					icon: 'carbon:piggy-bank',
					tag: 'cost-fees',
					tsKey: 'cost.cost-fees',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVGDTNW9PDQNXK6TF1T',
					icon: 'carbon:piggy-bank',
					tag: 'cost-free',
					tsKey: 'cost.cost-free',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'INCLUDE',
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01H6P8SSY4C141YH7BAC1RW7KJ',
		tag: 'crisis-support-community',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVN72D7XEBZZJXCJQXQ',
					icon: '️‍️‍✊🏿',
					tag: 'bipoc-comm',
					tsKey: 'srvfocus.bipoc-comm',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H6P951P0V3CR807P8KRH82S1',
					icon: '🌳',
					tag: 'elders',
					tsKey: 'crisis-support-community.elders',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H6P8T277D0C8HFQA6N09FJWD',
					icon: '🏳️‍🌈',
					tag: 'general-lgbtq',
					tsKey: 'crisis-support-community.general-lgbtq',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVQCZPA3Z5GW6J3MQHW',
					icon: '🌱',
					tag: 'lgbtq-youth-focus',
					tsKey: 'srvfocus.lgbtq-youth-focus',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVPSYBCYF37B44WP6CZ',
					icon: '🏳️‍⚧️',
					tag: 'trans-comm',
					tsKey: 'srvfocus.trans-comm',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVGHPW1Y72SA8377623',
		tag: 'eligibility-requirements',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVGSAZXGR4JAVHEK6ZC',
					icon: null,
					tag: 'elig-age',
					tsKey: 'eligibility.elig-age',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVJDKVF1HV7559CNZCY',
					icon: null,
					tag: 'other-describe',
					tsKey: 'eligibility.other-describe',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVH9DPBZ968VXGE50E7',
					icon: null,
					tag: 'req-medical-insurance',
					tsKey: 'eligibility.req-medical-insurance',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'EXCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVHZ599M48CMSPGDCSC',
					icon: null,
					tag: 'req-photo-id',
					tsKey: 'eligibility.req-photo-id',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'EXCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVH0GQK0GAJR5D952V3',
					icon: null,
					tag: 'req-proof-of-age',
					tsKey: 'eligibility.req-proof-of-age',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'EXCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVHEVX4PMNN077ASQMG',
					icon: null,
					tag: 'req-proof-of-income',
					tsKey: 'eligibility.req-proof-of-income',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'EXCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVHGMVCAY1G5BWF1PFB',
					icon: null,
					tag: 'req-proof-of-residence',
					tsKey: 'eligibility.req-proof-of-residence',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'EXCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVJH8MADHYTHBV54CER',
					icon: null,
					tag: 'req-referral',
					tsKey: 'eligibility.req-referral',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: 'EXCLUDE',
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVGJ5GD2WHNJDPSFNRW',
					icon: null,
					tag: 'time-appointment-required',
					tsKey: 'eligibility.time-appointment-required',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVJQQ68XGSBXM976BDF',
		tag: 'languages',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVJGDDWTR5D0C8BY357',
					icon: null,
					tag: 'all-languages-by-interpreter',
					tsKey: 'lang.all-languages-by-interpreter',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVJF09GXY5N5CKMSANJ',
					icon: null,
					tag: 'american-sign-language',
					tsKey: 'lang.american-sign-language',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVJ8K180CNX339BTXM2',
					icon: null,
					tag: 'lang-offered',
					tsKey: 'lang.lang-offered',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVRSN3W3GYZZ43WCW24',
		tag: 'law-practice-options',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVRH531R2HAV8DMDZSC',
					icon: null,
					tag: 'corp-law-firm',
					tsKey: 'userlawpractice.corp-law-firm',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVSE2074QZJ4SKEW74J',
					icon: null,
					tag: 'law-other',
					tsKey: 'userlawpractice.law-other',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVRS8XEJ3TJBBEQJ707',
					icon: null,
					tag: 'law-school-clinic',
					tsKey: 'userlawpractice.law-school-clinic',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVRFPRQCQHNJA6BM3XP',
					icon: null,
					tag: 'legal-nonprofit',
					tsKey: 'userlawpractice.legal-nonprofit',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVMNHV2ZS5875JWCRJ7',
		tag: 'organization-leadership',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVNPKMHYK12DDRVC1VJ',
					icon: '🤎',
					tag: 'bipoc-led',
					tsKey: 'orgleader.bipoc-led',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: '#F1DD7F',
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVN3JX2J7REFFT5NAMS',
					icon: '️‍️‍✊🏿',
					tag: 'black-led',
					tsKey: 'orgleader.black-led',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: '#C77E54',
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVNHMF72WHVKRF6W4TA',
					icon: '️‍️‍🌎',
					tag: 'immigrant-led',
					tsKey: 'orgleader.immigrant-led',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: '#79ADD7',
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVN3RYX9JMXDZSQZM70',
					icon: '️‍🏳️‍⚧️',
					tag: 'trans-led',
					tsKey: 'orgleader.trans-led',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: '#7C4A6B',
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVKAMMGPD71H90XRJ38',
		tag: 'service-access-instructions',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVKFM4TDY4QRK4AR2ZW',
					icon: null,
					tag: 'accessemail',
					tsKey: 'serviceaccess.accessemail',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVKMRHFD8SMDAZM3SSM',
					icon: null,
					tag: 'accessfile',
					tsKey: 'serviceaccess.accessfile',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVMYXMS8ARA3GE7HZFD',
					icon: null,
					tag: 'accesslink',
					tsKey: 'serviceaccess.accesslink',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVMH6AE94EXN7T5A87C',
					icon: null,
					tag: 'accesslocation',
					tsKey: 'serviceaccess.accesslocation',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVMKTFWCKBVVFJ5GMY0',
					icon: null,
					tag: 'accessphone',
					tsKey: 'serviceaccess.accessphone',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVMSX7T1WDNZ5QEHKWT',
					icon: null,
					tag: 'accesspublictransit',
					tsKey: 'serviceaccess.accesspublictransit',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVMMF19AX2KPBTMV6P3',
					icon: null,
					tag: 'accesstext',
					tsKey: 'serviceaccess.accesstext',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVNXMNJNV47BF2BPM1R',
		tag: 'service-focus',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVPCVX8F3B7M30ZJEHW',
					icon: '️‍️‍🌎',
					tag: 'asylum-seekers',
					tsKey: 'srvfocus.asylum-seekers',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVN72D7XEBZZJXCJQXQ',
					icon: '️‍️‍✊🏿',
					tag: 'bipoc-comm',
					tsKey: 'srvfocus.bipoc-comm',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVQ7SYGD3KM8WP9X50B',
					icon: '🏳️‍⚧️',
					tag: 'gender-nc',
					tsKey: 'srvfocus.gender-nc',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVRMQFJ9AMA633SQQGV',
					icon: '💛',
					tag: 'hiv-comm',
					tsKey: 'srvfocus.hiv-comm',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVPTK9555WHJHDBDA2J',
					icon: '️‍️‍🌎',
					tag: 'immigrant-comm',
					tsKey: 'srvfocus.immigrant-comm',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVQCZPA3Z5GW6J3MQHW',
					icon: '🌱',
					tag: 'lgbtq-youth-focus',
					tsKey: 'srvfocus.lgbtq-youth-focus',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVPJERY0GS9D7F56A23',
					icon: '️‍️‍🌎',
					tag: 'resettled-refugees',
					tsKey: 'srvfocus.resettled-refugees',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVQ8AGBKBBZJWTHNP2F',
					icon: '🗣️',
					tag: 'spanish-speakers',
					tsKey: 'srvfocus.spanish-speakers',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVPSYBCYF37B44WP6CZ',
					icon: '🏳️‍⚧️',
					tag: 'trans-comm',
					tsKey: 'srvfocus.trans-comm',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVQX4M8DY1FSAYSJSSK',
					icon: '🏳️‍⚧️',
					tag: 'trans-fem',
					tsKey: 'srvfocus.trans-fem',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVQEFWW42MBAD64BWXZ',
					icon: '🏳️‍⚧️',
					tag: 'trans-masc',
					tsKey: 'srvfocus.trans-masc',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVQVEGH6W3A2ANH1QZE',
					icon: '🌱',
					tag: 'trans-youth-focus',
					tsKey: 'srvfocus.trans-youth-focus',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVSQWE2Y2RF3DT2VEYX',
		tag: 'service-provider-options',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01H2TK83N5E52PPP828SD88KP8',
					icon: null,
					tag: 'userserviceprovider.case-mananger',
					tsKey: 'userserviceprovider.case-mananger',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVTTZ83PZR61M37R8R7',
					icon: null,
					tag: 'userserviceprovider.community-org',
					tsKey: 'userserviceprovider.community-org',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVSPXWJJPFG9DKXESEK',
					icon: null,
					tag: 'userserviceprovider.healthcare',
					tsKey: 'userserviceprovider.healthcare',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H2TM092CFVG6H0MR148AVAP7',
					icon: null,
					tag: 'userserviceprovider.lawyer',
					tsKey: 'userserviceprovider.lawyer',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H2TM0AJHVK8TSR8JNFANFNZ7',
					icon: null,
					tag: 'userserviceprovider.other',
					tsKey: 'userserviceprovider.other',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H2TM09EG0G84NXH40G5TESB5',
					icon: null,
					tag: 'userserviceprovider.paralegal',
					tsKey: 'userserviceprovider.paralegal',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H2TM09RAK024ZDZQ6FSY0TXB',
					icon: null,
					tag: 'userserviceprovider.social-worker',
					tsKey: 'userserviceprovider.social-worker',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01GW2HHFVTN6MSCMBW740Y7HN1',
					icon: null,
					tag: 'userserviceprovider.student-club',
					tsKey: 'userserviceprovider.student-club',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H2TM0A19DD6S97DNH76ZVP40',
					icon: null,
					tag: 'userserviceprovider.teacher',
					tsKey: 'userserviceprovider.teacher',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
			{
				attribute: {
					id: 'attr_01H2TM0AA4CZXJJHMXHE1PHMVV',
					icon: null,
					tag: 'userserviceprovider.therapist-counselor',
					tsKey: 'userserviceprovider.therapist-counselor',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
	{
		id: 'attc_01GW2HHFVKM2PSHFWVFM0TWX1P',
		tag: 'system',
		icon: null,
		ns: 'attribute',
		attributes: [
			{
				attribute: {
					id: 'attr_01GW2HHFVK8KPRGKYFSSM5ECPQ',
					icon: null,
					tag: 'incompatible-info',
					tsKey: 'sys.incompatible-info',
					tsNs: 'attribute',
					showOnLocation: null,
					filterType: null,
					iconBg: null,
				},
			},
		],
	},
] as const

export type AttributesByCategory = (typeof attributesByCategory)[number]
